module.exports = __webpack_public_path__ + "img/list7.01a52a75.jpg";